import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { upPlatform, addPlatform, update } from "@/api/platform";
export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    var validate = function validate(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseInput')));
      } else if (/[A-Z\u4e00-\u9fa5]/.test(value)) {
        callback(new Error(_this.$t('cannotContainUppercaseChinese')));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      form: {
        platform_name: "",
        status: "1",
        platform_mark: ""
      },
      rules: {
        platform_name: [{
          required: true,
          message: this.$t('pleaseInputPlatformName'),
          trigger: "blur"
        }],
        platform_mark: [{
          required: true,
          validator: validate,
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: this.$t('pleaseSelectPlatformStatus'),
          trigger: "change"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  created: function created() {},
  methods: {
    // 打开修改新增
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$upPlatform, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (id == 't') {
                  _this2.titleName = "addPlatform";
                  _this2.form = {
                    platform_name: "",
                    status: "1",
                    platform_mark: ""
                  };
                }

                _this2.id = id;

                if (!(id != "t")) {
                  _context.next = 14;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 14;
                  break;
                }

                _this2.titleName = "modifyPlatform";
                tid = {
                  id: id
                };
                _context.next = 9;
                return upPlatform(tid);

              case 9:
                _yield$upPlatform = _context.sent;
                data = _yield$upPlatform.data;
                _this2.form.platform_name = data.platform_name;
                _this2.form.status = String(data.status);
                _this2.form.platform_mark = data.platform_mark;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 关闭弹窗或取消修改新增
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
      this.$refs.ruleForm.clearValidate();
    },
    // 确定添加修改
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          if (_this3.titleName == "addPlatform") {
            _this3.form.id = _this3.id;
            addPlatform(_this3.form).then(function (res) {
              if (res.status == 200) {
                Message.success(_this3.$t('operationSuccess'));

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }

          if (_this3.titleName == "modifyPlatform") {
            _this3.form.id = _this3.id;
            update(_this3.form).then(function (res) {
              if (res.status == 200) {
                Message.success(_this3.$t('operationSuccess'));

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }
        }
      });
    }
  }
};